import React from 'react';
import { Grid } from 'components/ui';
import { useFilter, initInspectionFilterValues } from 'contexts/filter';
import { endOfDay, addDays } from 'date-fns';
import { DescriptionTypography } from 'components/styles_components/typography';
import { FormattedMessage } from 'react-intl';
import InspectionsCard from 'components/dashboard/inspections_card';
import InspectionFactory from 'utils/inspection';
import InspectionStatusFactory from 'utils/inspection_state';

const Inspections = ({ userData, spaceData }) => {
  const { setInspectionsFilter } = useFilter();
  const inspectionFactory = InspectionFactory();
  const inspectionStatusFactory = InspectionStatusFactory();
  const incomingDate = endOfDay(addDays(new Date(), 7 * inspectionFactory.PENDING_WEEKS));
  const overdueDate = endOfDay(new Date());

  return (
    <Grid container columnSpacing={2}>
      <InspectionsCard
        label={<FormattedMessage id="inspection.overdue.count" />}
        className={spaceData.overdueInspectionsTotal > 0 ? 'overdue' : ''}
        total={spaceData.overdueInspectionsTotal}
        setInspectionsFilter={() => {
          setInspectionsFilter({
            ...initInspectionFilterValues,
            dueDateTo: overdueDate,
            status: inspectionStatusFactory.PENDING,
          });
        }}
      />
      <InspectionsCard
        label={<FormattedMessage id="inspection.incoming.count" />}
        className={spaceData.incomingInspectionsTotal > 0 ? 'incoming' : ''}
        total={spaceData.incomingInspectionsTotal}
        setInspectionsFilter={() => {
          setInspectionsFilter({
            ...initInspectionFilterValues,
            dueDateTo: incomingDate,
            status: inspectionStatusFactory.PENDING,
          });
        }}
      />
      <InspectionsCard
        label={<FormattedMessage id="inspection.all" />}
        total={spaceData.pendingInspectionsTotal}
        setInspectionsFilter={() => {}}
      />

      <Grid size={{ xs: 12 }}>
        <DescriptionTypography>
          <FormattedMessage id="inspection.inspector" />
        </DescriptionTypography>
      </Grid>

      <InspectionsCard
        label={<FormattedMessage id="inspection.overdue.count" />}
        className={userData.inspectorOverdueInspectionsTotal > 0 ? 'overdue' : ''}
        total={userData.inspectorOverdueInspectionsTotal}
        setInspectionsFilter={() => {
          setInspectionsFilter({
            ...initInspectionFilterValues,
            dueDateTo: overdueDate,
            status: inspectionStatusFactory.PENDING,
            inspectorId: userData.id,
          });
        }}
      />
      <InspectionsCard
        label={<FormattedMessage id="inspection.incoming.count" />}
        className={userData.inspectorIncomingInspectionsTotal > 0 ? 'incoming' : ''}
        total={userData.inspectorIncomingInspectionsTotal}
        setInspectionsFilter={() => {
          setInspectionsFilter({
            ...initInspectionFilterValues,
            dueDateTo: incomingDate,
            status: inspectionStatusFactory.PENDING,
            inspectorId: userData.id,
          });
        }}
      />
      <InspectionsCard
        label={<FormattedMessage id="all" />}
        total={userData.inspectorPendingInspectionsTotal}
        setInspectionsFilter={() => {
          setInspectionsFilter({ ...initInspectionFilterValues, inspectorId: userData.id });
        }}
      />
    </Grid>
  );
};

export default Inspections;
